var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIfaRates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5429 3H4.45714C3.65238 3 3 3.65238 3 4.45714V35.5429C3 36.3476 3.65238 37 4.45714 37H35.5429C36.3476 37 37 36.3476 37 35.5429V4.45714C37 3.65238 36.3476 3 35.5429 3Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7142 10.2858V37.0001",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2858 10.2858V37.0001",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.3572H37",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23.6428H12.7143",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2858 23.6428H37.0001",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 30.9286H37",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6568 22.5992C18.3745 22.5992 18.9564 22.0174 18.9564 21.2996C18.9564 20.5819 18.3745 20 17.6568 20C16.939 20 16.3572 20.5819 16.3572 21.2996C16.3572 22.0174 16.939 22.5992 17.6568 22.5992Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0718 27.7518C23.7896 27.7518 24.3714 27.17 24.3714 26.4522C24.3714 25.7344 23.7896 25.1526 23.0718 25.1526C22.3541 25.1526 21.7722 25.7344 21.7722 26.4522C21.7722 27.17 22.3541 27.7518 23.0718 27.7518Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5232 29.2679L22.6386 17.5714",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.2858H37",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfaRates);
export default __webpack_public_path__ + "static/media/IFARates.e503d140bbc1444d1b76db165b656816.svg";
export { ForwardRef as ReactComponent };